var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AuthHeading',{attrs:{"title":"Reset the password","sub-title":_vm.resetPasswordHandlerSubTitle}}),_c('AuthForm',{attrs:{"is-reset-password-set-password":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }